import Logo from '../components/Logo'

export default function Terms() {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{ background: '#185FA5', padding: '24px 20px', textAlign: 'center' }}>
        <Logo variant="light" width="180px" maxWidth="180px" style={{ margin: '0 auto' }} />
      </div>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '32px 20px 60px' }}>
        <button type="button" onClick={() => { window.location.href = '/' }} style={backLink}>← Back to home</button>

        <h1 style={{ fontSize: '24px', fontWeight: '600', margin: '20px 0 4px' }}>Terms of use</h1>
        <p style={{ fontSize: '13px', color: '#888', marginBottom: '28px' }}>Last updated: 19 June 2026</p>

        <Section title="Using GAA Match Tracker">
          <p>
            GAA Match Tracker is provided free of charge to GAA clubs for tracking matches, fixtures, and results. By creating
            an account or using the public-facing pages, you agree to these terms.
          </p>
        </Section>

        <Section title="Your account">
          <p>
            You're responsible for keeping your password secure and for any activity that happens under your account. If you
            think your account has been accessed without your permission, please let us know via the{' '}
            <a href="/contact" style={linkStyle}>contact page</a> as soon as possible.
          </p>
          <p>
            Club admins and squad admins are responsible for approving coaches within their own club or squad, and for the
            accuracy of the information entered for their team.
          </p>
        </Section>

        <Section title="Acceptable use">
          <p>Please don't use GAA Match Tracker to:</p>
          <ul style={listStyle}>
            <li>Enter false, misleading, or abusive content</li>
            <li>Impersonate a club, coach, or player you're not authorised to represent</li>
            <li>Attempt to access another club's or squad's data without permission</li>
            <li>Disrupt or interfere with the normal operation of the service</li>
          </ul>
          <p>
            We reserve the right to suspend or remove accounts that breach these terms.
          </p>
        </Section>

        <Section title="Public pages">
          <p>
            Fixture, result, and live score information that a club chooses to track is made available on a public page that
            doesn't require login, so supporters can follow along. Clubs and coaches are responsible for what they choose to
            enter and publish through this feature.
          </p>
        </Section>

        <Section title="No warranty">
          <p>
            GAA Match Tracker is provided "as is," without any warranty of uninterrupted or error-free operation. While we
            take reasonable care to keep the service running reliably, we can't guarantee it will always be available, and we
            recommend not relying on it as the sole record of match data for anything safety-critical or official.
          </p>
        </Section>

        <Section title="Limitation of liability">
          <p>
            To the fullest extent permitted by law, we are not liable for any indirect or consequential loss arising from your
            use of, or inability to use, GAA Match Tracker, including loss of data.
          </p>
        </Section>

        <Section title="Changes to the service or these terms">
          <p>
            We may update these terms, or change, suspend, or discontinue any part of the service, at any time. We'll update
            the "last updated" date above whenever these terms change.
          </p>
        </Section>

        <Section title="Governing law">
          <p>
            These terms are governed by the laws of Ireland.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about these terms can be sent via our <a href="/contact" style={linkStyle}>contact page</a>.
          </p>
        </Section>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '28px' }}>
      <h2 style={{ fontSize: '17px', fontWeight: '600', marginBottom: '10px', color: '#185FA5' }}>{title}</h2>
      <div style={{ fontSize: '14px', color: '#333', lineHeight: '1.7' }}>{children}</div>
    </div>
  )
}

const backLink = { background: 'none', border: 'none', color: '#185FA5', fontSize: '13px', cursor: 'pointer', textDecoration: 'underline', padding: 0 }
const linkStyle = { color: '#185FA5' }
const listStyle = { margin: '8px 0', paddingLeft: '20px', lineHeight: '1.8' }